import { create } from "zustand";
import { localeStorageManager } from "@config/localstorage";

type State = { identityToken: string | null };

export const useIdentityTokenStore = create<State>(() => ({
  identityToken: (localeStorageManager.getIdentityToken() as string | null) ?? null,
}));

export const getIdentityToken = (): string | null => useIdentityTokenStore.getState().identityToken;

export const setIdentityToken = (token: string): void => {
  localeStorageManager.setIdentityToken(token);
  useIdentityTokenStore.setState({ identityToken: token });
};

export const removeIdentityToken = (): void => {
  localeStorageManager.removeIdentityToken();
  useIdentityTokenStore.setState({ identityToken: null });
};
